import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MainCmsComponents } from '@core/const';
import { SdvorTabBarItemComponent } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { OpenMobileCategoriesComponent } from './open-mobile-categories.component';

@NgModule({
  declarations: [OpenMobileCategoriesComponent],
  imports: [
    AsyncPipe,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [MainCmsComponents.CmsOpenMobileCategoriesComponent]: {
          component: OpenMobileCategoriesComponent,
        },
      },
    }),
    SdvorTabBarItemComponent,
  ],
  exports: [OpenMobileCategoriesComponent],
})
export class OpenMobileCategoriesModule {}
